import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { Navigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Icon } from 'semantic-ui-react';
import { renewPassword } from '../../../actions/pass';
import { TopBarPublic } from '../../../components/TopBar/TopBarPublic';

export const RenewPassword = () => {
  console.log('text');

  const { loading } = useSelector((state) => state.ui);
  // Get location
  const location = useLocation();
  const { correo = '', token = '' } = queryString.parse(location.search);
  if (!correo || !token) {
    // window.location.href = '/';
    <Navigate to="/" />;
  }

  // Dispatch
  const dispatch = useDispatch();

  // State Show hide password
  const [showPassword, setShowPassword] = useState(false);
  const handlerShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Validate lenght of password
  const [validInput, setValidInput] = useState({
    password: '',
  });
  const { password } = validInput;

  useEffect(() => {
    if (password.length > 6) {
      document.querySelector('#DisableButton').classList.remove('disabled');
    } else {
      document.querySelector('#DisableButton').classList.add('disabled');
    }
  }, [password]);

  const handleInputChange = ({ target }) => {
    setValidInput({
      ...validInput,
      [target.name]: target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    var data = JSON.stringify({
      requestContent: {
        credentials: {
          email: correo,
          password: password,
          token: token,
        },
      },
    });

    dispatch(renewPassword(data));
  };

  return (
    <>
      <TopBarPublic />
      <div className="container">
        <div className="row full-height">
          <div className="col text-center">
            <h1>Renueva tu contraseña</h1>
            <Form
              onSubmit={onSubmit}
              className="general-form small-form mtop30"
            >
              <label>
                Nueva contraseña
                <Input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Crea una nueva contraseña"
                  className="input-text"
                  value={password}
                  onChange={handleInputChange}
                  icon={
                    showPassword ? (
                      <Icon
                        name="eye slash outline"
                        link
                        onClick={handlerShowPassword}
                      />
                    ) : (
                      <Icon name="eye" link onClick={handlerShowPassword} />
                    )
                  }
                />
              </label>
              <Button
                loading={loading}
                id="DisableButton"
                className="cta disabled"
              >
                Continuar
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
